export default "__VITE_ASSET__d5a4db8f__"